module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/2-f1468f062c3053844b95ef8bbeccd31d.jpg";